import React, { forwardRef, useState } from "react";
import "../../styles/ComponentsStyles/Universal/ToggleBtn.style.css";
import PropTypes from "prop-types";
const ToggleBtn = forwardRef(
  ({ type, label = "", value, setFieldValue, name }, ref) => {
    const [checkedInput, setChechedInput] = useState(false);

    const changeButtonStatus = (e) => {
      if (label !== "") {
        if (e.target.value === value) {
          setChechedInput(true);
        } else {
          setChechedInput(false);
        }
        if (e.target.checked) {
          setFieldValue(e.target.value);
        }
      } else {
        setChechedInput(!checkedInput);
        setFieldValue(e, e.target.value);
      }
    };

    return (
      <div className="toggleBtn">
        <label htmlFor={label}>{label}</label>
        <input
          ref={ref}
          type={type}
          checked={checkedInput}
          name={name}
          value={value}
          onChange={(e) => changeButtonStatus(e)}
          required
        />
      </div>
    );
  }
);

export default ToggleBtn;

ToggleBtn.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  setFieldValue: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
